import {
  TABLE_NUMBER_CELL_SORTING_OPTIONS,
  TABLE_TEXT_CELL_SORTING_OPTIONS,
} from '../Table.constants'
import { isDateCell, isNumberCell } from '../Table.utils'

export function getSortingOptions(orderingField) {
  switch (true) {
    case isNumberCell(orderingField):
    case isDateCell(orderingField):
      return TABLE_NUMBER_CELL_SORTING_OPTIONS

    default:
      return TABLE_TEXT_CELL_SORTING_OPTIONS
  }
}
